import React from 'react'
import { Field } from 'redux-form'
import { Checkbox } from 'lp-components'
import TermsAgreementContent from './TermsAgreementContent'

function TermsAgreementField() {
  return (
    <>
      <label htmlFor="termsAgreement">
        Please Acknowledge<span className="required-indicator">*</span>
      </label>
      <Field
        className="checkbox inline-checkbox"
        component={Checkbox}
        labelComponent={TermsAgreementContent}
        name="termsAgreement"
        required
        requiredIndicator="*"
      />
    </>
  )
}

export default TermsAgreementField
